'use client'

import { initSdks } from '~/lib/init-sdks'

// Must run in the client bundle — root layout is a Server Component,
// so init there only mutates the server axios instance (prod default stays).
initSdks()

export const InitSdks = () => null
